// Shared lineage strip -- the UX audit's Section 12 "what is this
// connected to" surface (docs/product/intelligence-console-ux-audit.md).
// Renders ONLY real, already-resolved upstream/downstream relationships
// the caller passes in (e.g. a recommendation's own opportunity_id /
// source_signal_ids, resolved against the workspace's already-fetched
// opportunities/signals lists). If a relationship cannot be resolved, the
// caller simply omits that item -- this component never invents a
// placeholder relationship and renders nothing at all when every item is
// unresolved.
//
// P1 Signals slice -- an item may optionally carry a real `onClick`
// (e.g. SignalsPage.js's existing "Related opportunity" navigation,
// preserved from the pre-migration SignalCard). Purely additive: an item
// with no `onClick` (every Recommendations lineage item today) renders
// exactly as before, a plain non-interactive block.

export function LineageStrip({ items = [], testId = 'lineage-strip' }) {
  const resolved = items.filter((item) => item && item.value);
  if (resolved.length === 0) return null;

  return (
    <div data-testid={testId} className="mb-3 space-y-1.5">
      {resolved.map((item, i) => {
        const content = (
          <>
            <p className="text-[9px] font-mono uppercase tracking-wide text-[var(--text-tertiary)]">{item.label}</p>
            <p className="text-[11px] text-[var(--text-secondary)] leading-snug">{item.value}</p>
          </>
        );
        const key = item.testId || i;
        const itemTestId = item.testId || `lineage-item-${i}`;
        if (typeof item.onClick === 'function') {
          return (
            <button key={key} type="button" onClick={item.onClick} data-testid={itemTestId} className="block w-full text-left hover:opacity-80">
              {content}
            </button>
          );
        }
        return (
          <div key={key} data-testid={itemTestId}>
            {content}
          </div>
        );
      })}
    </div>
  );
}
